import { defineComponent, ref, onMounted, watch, reactive } from '@vue/composition-api';
import { useGetAllHowToArticlesQuery } from '@/generated-types/graphql.types';
import { dateFormat } from '@/util/dates';
import { SITE_URL } from '@/App.vue';
import { visibilityChanged } from '@/util/globalHelpers';
import { imageUrl, imageSrcSet, imagePlaceholder } from '@/util/images';
import { useGetLocalizedPath } from '@/util/globalHelpers';
import { useMeta } from '@/shared/composables/useMeta';
import { HowToRoutes } from '@/HowTo/howto.const';
import qs from 'query-string';
import PagePagination from '@/components/PagePagination.vue';
import EventBus from '@/shared/services/eventBus';
import BackButton from '@/components/BackButton.vue';
export default defineComponent({
    components: { BackButton, PagePagination },
    setup(_, context) {
        const { root } = context;
        const stories = ref([]);
        const page = ref(1);
        const pageSize = ref(10);
        const maxPage = ref(1);
        const getAllHowToArticlesQueryVariables = reactive({
            pagination: {
                page: page.value,
                size: pageSize.value
            }
        });
        const { onResult, refetch } = useGetAllHowToArticlesQuery(getAllHowToArticlesQueryVariables);
        onResult(result => {
            if (!result?.data?.get_all_how_to_articles)
                return;
            maxPage.value = Math.ceil(result.data.get_all_how_to_articles.total / pageSize.value);
            const _stories = result.data.get_all_how_to_articles.stories;
            stories.value = _stories.map((story) => {
                const data = JSON.parse(story.story);
                const title = data.name;
                return {
                    link: globalThis.$i18n.locale === 'nl'
                        ? data.full_slug
                        : data.translated_slugs[0].path || data.full_slug,
                    title: globalThis.$i18n.locale === 'nl'
                        ? title
                        : data.translated_slugs[0].name || title,
                    image: {
                        alt: data.content.thumbnail.alt,
                        src: data.content.thumbnail.filename
                    },
                    date: dateFormat(data.created_at, 'DD MMM YY')
                };
            });
            if (!_stories.length) {
                page.value = 1; // see page.value watcher, it will refetch the data
            }
            history.replaceState({}, null, page.value === 1 ? window.location.pathname : `?page=${page.value}`);
            useMeta({
                title: root.$i18n.t('meta.how_to.title_tag'),
                description: root.$i18n.t('meta.how_to.description_tag'),
                url: `${SITE_URL}/${HowToRoutes.HowTo}`,
                noIndex: false
            });
        });
        EventBus.$on('languageSelected', selectedLocale => {
            if (!selectedLocale)
                return;
            refetch(getAllHowToArticlesQueryVariables);
        });
        // Same two wrappers as Blog.vue. This file carried a byte-identical copy
        // of getImageLink, which patch 01 replaces there and does not mention
        // here -- removing a duplicated helper in one of its two homes leaves the
        // duplication, so it is done in both.
        const cardImage = (src) => imageUrl(src, { width: root.$mq.phone ? 320 : 520 });
        const cardSrcSet = (src) => imageSrcSet(src, [320, 520, 1040]);
        watch(() => page.value, () => {
            if (page.value) {
                getAllHowToArticlesQueryVariables.pagination.page = page.value;
                refetch(getAllHowToArticlesQueryVariables);
                root.$scrollTo('#stories', 500, {
                    offset: -200
                });
            }
        }, { immediate: true });
        onMounted(() => {
            const currentQueryParams = qs.parse(location.search, {
                arrayFormat: 'bracket'
            });
            page.value =
                currentQueryParams.page && Number(currentQueryParams.page) > 0
                    ? Number(currentQueryParams.page)
                    : 1;
        });
        return {
            maxPage,
            stories,
            page,
            cardImage,
            cardSrcSet,
            imagePlaceholder,
            visibilityChanged,
            useGetLocalizedPath
        };
    }
});
